import { render, staticRenderFns } from "./dg-upload.vue?vue&type=template&id=7042ac50&scoped=true"
import script from "./dg-upload.vue?vue&type=script&lang=js"
export * from "./dg-upload.vue?vue&type=script&lang=js"
import style0 from "./dg-upload.vue?vue&type=style&index=0&id=7042ac50&prod&lang=less&scoped=true"
import style1 from "./dg-upload.vue?vue&type=style&index=1&id=7042ac50&prod&lang=css"
import style2 from "./dg-upload.vue?vue&type=style&index=2&id=7042ac50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7042ac50",
  null
  
)

export default component.exports